import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ProfileColPagesssProvider } from "./context/ProfileColPagesssContext";

import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ProfileColPagesssProvider>
      <App />
    </ProfileColPagesssProvider>
  </React.StrictMode>
);

reportWebVitals();